// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import { isMobile } from 'common/screen'
import { mediaMax } from 'components/styles/_media'
import RoomCardSliderItem from 'components/molecules/room/RoomCardSliderItem'
import type { Room as RoomType } from 'types/room'

const SlideArrowsContainer = styled.div`
  .fa-chevron-left,
  .fa-chevron-right {
    color: #666;
    position: absolute;
    top: 35%;
    font-size: 45px;
  }
  .fa-chevron-left {
    left: -48px;
  }
  .fa-chevron-right {
    right: -48px;
  }
  .slick-disabled {
    .fa-chevron-left,
    .fa-chevron-right {
      color: #f0f0f0;
    }
  }
  ${mediaMax.desktop`
    display: none;
  `};
`

const Hover = styled.a`
  &:hover {
    opacity: 0.8;
  }
`

type PropTypes = {
  title: string,
  addedFavoriteListName?: ?string,
  roomList: Array<RoomType>,
  showingFavoriteListTooltipList: Array<string>,
  onClickFavorite: Function,
}

const MAX_DISPLAY_COUNT = 3
const slickSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  fade: false,
  swipe: true,
  swipeToSlide: true,
  touchMove: false,
  accessibility: false,
  slidesToShow: MAX_DISPLAY_COUNT,
  slidesToScroll: MAX_DISPLAY_COUNT,
}

export default class RoomCardSlider extends React.Component<PropTypes> {
  slider: Slider
  props: PropTypes

  render() {
    const {
      title,
      roomList,
      addedFavoriteListName,
      showingFavoriteListTooltipList,
    } = this.props

    const rooms = [].concat(roomList)
    if (rooms.length === 0) {
      return null
    }

    let isVisibleSlideArrows = true
    if (rooms.length < MAX_DISPLAY_COUNT) {
      isVisibleSlideArrows = false
    }

    while (!isMobile() && rooms.length < MAX_DISPLAY_COUNT) {
      rooms.push({
        isPaddingCard: true,
        prices: [],
        thumbnails: [],
      })
    }

    const roomListWrapper = () => {
      const roomsJSX = rooms.map((room, index) => (
        <li
          className="col-sm-12 col-md-4 mod__units-item__list"
          key={`neighborhood_room_${index}`}
        >
          <RoomCardSliderItem
            room={room}
            addedFavoriteListName={addedFavoriteListName}
            onClickFavorite={(e: Event) => this.props.onClickFavorite(e, room)}
            showingFavoriteListTooltipList={showingFavoriteListTooltipList}
          />
        </li>
      ))

      if (isMobile()) {
        return roomsJSX
      }

      return (
        <Slider
          ref={refs => {
            this.slider = refs
          }}
          {...slickSettings}
        >
          {roomsJSX}
        </Slider>
      )
    }

    return (
      <Fragment>
        <h2 className="space-main__headline-big">{title}</h2>
        <div className="mod__units-item">
          <ul className="row" style={{ overflow: 'hidden' }}>
            {roomListWrapper()}
          </ul>
          {isVisibleSlideArrows ? (
            <SlideArrowsContainer>
              <Hover
                href="#"
                onClick={e => {
                  e.preventDefault()
                  this.slider.slickPrev()
                }}
              >
                <i className="fa fa-chevron-left" />
              </Hover>
              <Hover
                href="#"
                onClick={e => {
                  e.preventDefault()
                  this.slider.slickNext()
                }}
              >
                <i className="fa fa-chevron-right" />
              </Hover>
            </SlideArrowsContainer>
          ) : null}
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/room/RoomCardSlider/index.jsx